import React, {memo, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {Item} from '@pb/kit-component-group';
import {StickyElement} from '@pb/kit-component-sticky-element';

import {
    AssignedAccountsSearchResultController,
    AssignedAccountsSearchResultView,
    accountSearchResultStateActions,
    accountSearchResultStateSelector,
} from './assigned-accounts-search-result';
import {AssignedAccountsToolsRibbon} from './components/assigned-accounts-tools-ribbon';

import type {UserShortInfo} from 'src/openapi/admin/models/UserShortInfo';

type WrapperProps = {
    user: UserShortInfo,
    place: string,
};

export const AssignedAccountsWrapper = memo(({user, place}: WrapperProps) => {
    const dispatch = useDispatch();
    const cacheKeys = useSelector(accountSearchResultStateSelector);

    useEffect(() => {
        dispatch(accountSearchResultStateActions.setSearchCriteria({accountManagerId: user.userId}));
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (!cacheKeys.searchCriteria.accountManagerId) {
        return null;
    }

    return <AssignedAccounts place={place} user={user}/>;
});

type Props = {
    place: string,
    user: UserShortInfo,
};

const AssignedAccounts = ({place, user}: Props) => (
    <AssignedAccountsSearchResultController place={place}>
        {props => (
            <Item grow={1}>
                <StickyElement className="sticky-tool-ribbon">
                    <AssignedAccountsToolsRibbon
                        user={user}
                        place={place}
                        adminId={props.adminId}
                        isLoading={props.isLoading}
                        getAllEntityIds={props.getAllEntityIds}
                        templates={props.templates}
                        activeSearchTemplate={props.activeSearchTemplate}
                        setActiveSearchTemplate={props.setActiveSearchTemplate}
                        loadTemplates={props.loadTemplates}
                        loadActiveSearchTemplate={props.loadActiveSearchTemplate}
                        refreshResults={props.refreshResults}
                    />
                </StickyElement>
                <AssignedAccountsSearchResultView
                    getAllEntityIds={props.getAllEntityIds}
                    place={place}
                    activeSearchTemplate={props.activeSearchTemplate}
                />
            </Item>
        )}
    </AssignedAccountsSearchResultController>
);
